// extracted by mini-css-extract-plugin
export default {"full_img":"FullScreenImage_full_img__cOpMs","image_cont":"FullScreenImage_image_cont__2JQS3","close":"FullScreenImage_close__AOmZT"};